import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IAppState } from '../../store';
import { NgRedux } from '@angular-redux/store';


@Component({
  selector: 'stay-mgmt-cancel-res-button',
  templateUrl: './cancel-res-button.component.html',
  styleUrls: ['./cancel-res-button.component.scss']
})
export class CancelResButtonComponent implements OnInit {
  @Input() messages;
  @Output() cancelResButtonClicked: EventEmitter<string>;
  enabled: boolean;
  translatedCancelRes: string;

  constructor(private _ngRedux: NgRedux<IAppState>) {
    this.cancelResButtonClicked = new EventEmitter();
  }

  ngOnInit() {
    this._ngRedux.subscribe(() => {

      // check to see if a failure has already occurred and disable the delete if true
      this.enabled = this._ngRedux.getState().acceptTerms
        && this._ngRedux.getState().reservation.cancellationNumber == null;
    });
  }

  onButtonClick(): void {
    if (this.enabled) {
      this.cancelResButtonClicked.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/cancel-res-button.component.ts